import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuditLog } from '@shared/models/audit-log.model';
import { SignedUrlObject } from '@shared/models/signedUrlObject.model';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  DestroyRequestSearchCriteria,
  DestroyRequestViewResponse,
  DestroyViewResponse
} from '../model/destroy-model';

@Injectable({
  providedIn: 'root'
})
export class DestroyService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.destroy;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getDestroyRequestList(criteria: DestroyRequestSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.requestList, {
      storeNo
    });
    const params = this.getParams(criteria);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getDestroyRequestView(docNo): Observable<DestroyRequestViewResponse> {
    const url = this.getFullUrlWithStoreNo(this.envService.requestView, docNo);

    return this.http.get<DestroyRequestViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  override getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrlWithStoreNo(this.envService.requestFileUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }

  getDestroyList(criteria: DestroyRequestSearchCriteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  getDestroyView(docNo): Observable<DestroyViewResponse> {
    const url = this.getFullUrlWithStoreNo(this.envService.view, docNo);

    return this.http.get<DestroyViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  getHistory(docNo: string): Observable<{ auditLogs: AuditLog[] }> {
    const url = this.getFullUrlWithStoreNo(this.envService.history, {
      docNo
    });

    return this.http.get<{ auditLogs: AuditLog[] }>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }
}
